export default __webpack_public_path__ + "locales/vi/People.json?hash=cbd1a9f28f06546a72d8bf9ae44ded98";